import {
  CircleCheck,
  Info,
  Loader2,
  OctagonX,
  TriangleAlert,
} from "lucide-react";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <SonnerToaster
      style={
        {
          "--normal-bg": "var(--secondary-background)",
          "--normal-text": "var(--secondary-foreground)",
          "--normal-border": "var(--secondary-border)",
          "--border-radius": "var(--radius-sm)",
        } as any
      }
      icons={{
        success: <CircleCheck style={{ width: "1rem", height: "1rem" }} />,
        info: <Info style={{ width: "1rem", height: "1rem" }} />,
        warning: <TriangleAlert style={{ width: "1rem", height: "1rem" }} />,
        error: <OctagonX style={{ width: "1rem", height: "1rem" }} />,
        loading: <Loader2 style={{ width: "1rem", height: "1rem" }} />,
      }}
      position="top-center"
      {...props}
    />
  );
};

export { Toaster };
